// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 606) return "static/chunks/b20d15d7-bdc047fa2318d384.js";
	if (chunkId === 908) return "static/chunks/908-7b62da28f1b632b2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"195":"3ead2077c78b2b63","225":"ef4380bc458b9bdf","358":"2f9b3b0bb087c26b","889":"b87b16a400522a8a"}[chunkId] + ".js";
};